<template>
  <button
    v-if="!href"
    type="button"
    :class="{
      'archive__button archive__subscribe-form-button': true,
      button: true,
      tinted,
      yellow: color === 'yellow',
      blue: color === 'blue',
      red: color === 'red',
      pending: pending,
      disabled: disabled,
    }"
  >
    <div class="archive__button-pending-indicator">
      <PendingIndicator v-if="pending" pending class="size-4" />
    </div>
    <div style="flex: 1; text-align: center">{{ text }}</div>
  </button>
  <a
    v-else
    type="button"
    :href="href"
    target="_blank"
    :class="{
      'archive__button archive__subscribe-form-button': true,
      tinted,
      yellow: color === 'yellow',
      blue: color === 'blue',
      red: color === 'red',
      disabled: disabled,
      pending: pending,
    }"
  >
    <div class="archive__button-pending-indicator">
      <PendingIndicator v-if="pending" pending class="size-4" />
    </div>
    <div style="flex: 1; text-align: center">{{ text }}</div>
  </a>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import PendingIndicator from "@/components/Utilities/PendingIndicator.vue";

type Color = "yellow" | "green" | "blue" | "red";
declare var TINT_COLOR: string;

defineProps<{
  href?: string;
  text: string;
  color: Color;
  pending?: boolean;
  disabled?: boolean;
}>();

const tinted = computed(() => TINT_COLOR !== "#0069FF");
</script>
